<!--
 * @Author: OnismYY 2848335733@qq.com
 * @LastEditTime: 2025-12-10 17:37:35
 * @FilePath: \h5-front\src\components\fast-app\index.vue
 * @Description: 快捷应用
-->
<template>
  <div>
    <v-card class="pb-2 rounded-0 pt-3">
      <!-- <template v-slot:subtitle>
        {{ groupedShortcuts.length > 0 ? $t('home.quickApp') : $t('home.rightAdd') }}
      </template>
      <template v-slot:append>
        <v-btn icon="mdi mdi-widgets-outline" variant="text" size="small" @click="editDialog = true"></v-btn>
      </template> -->

      <v-window v-model="onboarding" class="mb-1 mx-2">
        <v-window-item :value="index + 1" v-for="(group, index) in groupedShortcuts" :key="index">
          <v-row>
            <v-col cols="3" sm="3" md="1" v-for="(item, itemIndex) in group" :key="itemIndex">
              <v-card variant="flat" link @click="jumpPage(item)">
                <v-card-text class="text-center pa-1">
                  <ali-icon-font :name="item.icon" size="2em" color="" />
                  <p class="mt-4 text-caption text-lg-subtitle-2" style="white-space: nowrap">
                    {{ translate_i18n(item.name) }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-window-item>
        <v-fab
          class="mt-4"
          icon="mdi mdi-widgets-outline"
          location="top end"
          size="x-small"
          absolute
          offset
          @click="editDialog = true"
          color="pink"
        ></v-fab>
      </v-window>

      <v-card-actions v-if="groupedShortcuts.length > 1" class="justify-center pa-0" style="min-height: auto">
        <v-item-group v-model="onboarding" class="text-center" mandatory>
          <v-item v-for="n in groupedShortcuts.length" :key="`btn-${n}`" v-slot="{ isSelected, toggle }" :value="n">
            <v-btn :variant="isSelected ? 'outlined' : 'text'" size="12" @click="toggle" rounded="2" color="primary">
              <v-card color="primary" style="width: 12px; height: 6px"></v-card>
            </v-btn>
          </v-item>
        </v-item-group>
      </v-card-actions>
    </v-card>

    <fast-app-edit
      :id="shortcutId"
      :shortcutsList="shortcutsList"
      :editDialog="editDialog"
      @closeDialog="closeDialogHandler"
    />
  </div>
</template>
<script setup>
import $toastMessage from '@/components/toast-message/index'
import { translate_i18n } from '@/plugins/i18n'
import { isEmpty } from '@/utils/common-utils'
import { useBisStore } from '@/stores/bis'
// import { useBisStore } from '@/stores/bis-store'
import { filterShortcuts } from './fast-store'
import { useCustomizeThemeStore } from '@/stores/customize-theme'
import { useAppStore } from '@/stores/app-store'
const appStore = useAppStore()

import quickIconsApi from '@/models/quick-icons-api'
import fastAppEdit from './fast-app-edit.vue'

const customizeThemeStore = useCustomizeThemeStore()
const bisStore = useBisStore()
const router = useRouter()

const onboarding = ref(1)
const editDialog = ref(false)

const shortcutsList = ref([])
const shortcutId = ref('')

// 获取快捷应用列表
const getShortcutsList = async () => {
  const res = await quickIconsApi.getShortcut()
  console.log('快捷应用列表>>>', JSON.stringify(res))
  shortcutId.value = res.id
  shortcutsList.value = filterShortcuts(res.quickIconsList)
}
getShortcutsList()

/** 计算基于当前基地信息的可访问菜单数组，且要存在产品权限的菜单才显示 */
const accessibleMenus = computed(() => {
  console.log('产品列表>>>', bisStore.productTypeList)
  const productList = bisStore.productTypeList
  const productCategories = productList || []

  if (!isEmpty(shortcutsList.value)) {
    return shortcutsList.value.filter((item) => item.menuKey.some((key) => productCategories.includes(key)))
  } else {
    return []
  }
})

/**计算数组数量，遍历到滑动模块中，实现app和PC端中菜单滑动列表 */
const groupedShortcuts = computed(() => {
  const groupSize = customizeThemeStore.isMobile ? 4 : 12 // 移动端一个版面显示4个，pc端一个版本显示12个,超过的滑动显示
  const groups = []
  // console.log(accessibleMenus.value);
  for (let i = 0; i < accessibleMenus.value.length; i += groupSize) {
    groups.push(accessibleMenus.value.slice(i, i + groupSize))
  }
  return groups
})

// 子组件触发关闭当前弹框
const closeDialogHandler = () => {
  getShortcutsList()
  editDialog.value = false
}

const jumpPage = (item) => {
  if (!isEmpty(item.link)) {
    router.push({ path: item.link })
  } else {
    $toastMessage.show({
      color: 'warning',
      variant: 'flat',
      message: `跳转${item.name}`
    })
  }
}

// 如果是登录或切换基地，需要默认跳转第一个产品
watch(accessibleMenus, (val) => {
  if (appStore.isJumpProduct && val.length > 0) {
    jumpPage(val[0])
  }
})
</script>
